module.exports = __webpack_public_path__ + "img/T10-MX4.4dd317e7.png";